module.exports = __webpack_public_path__ + "47447bb17f9ef5c05d5cd7bd1b93f3dd.eot";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-thin.eot
// module id = 24
// module chunks = 0